/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchProductsResponseDto } from '../../models/search-products-response-dto';

export interface ProductsControllerSearch$Params {
  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id': string;
  page?: number;
  perPage?: number;
  q: string;
}

export function productsControllerSearch(
  http: HttpClient,
  rootUrl: string,
  params: ProductsControllerSearch$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<SearchProductsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, productsControllerSearch.PATH, 'get');
  if (params) {
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.query('page', params.page, {});
    rb.query('perPage', params.perPage, {});
    rb.query('q', params.q, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchProductsResponseDto>;
    })
  );
}

productsControllerSearch.PATH = '/api/v1/products';
